document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("hero-video")) {
    customElements.define(
      "hero-video",
      class HeroVideo extends HTMLElement {
        constructor() {
          super();
          this.video = this.querySelector(".hero-video");
          this.videoDeskSrc = this.video.getAttribute("data-src");
          this.videoMobileSrc = this.video.getAttribute("data-mobile-src");
          this.prevWidth = window.innerWidth;
          this.changeVideoSource = this.changeVideoSource.bind(this);

          if (this.videoMobileSrc) {
            window.addEventListener("resize", this.changeVideoSource);
          }

          this.changeVideoSource();
        }

        connectedCallback() {
          if (this.video) {
            if (window.innerWidth >= 750 || this.videoMobileSrc == "") {
              this.video.src = this.videoDeskSrc;
            } else if (this.videoMobileSrc) {
              this.video.src = this.videoMobileSrc;
            }
          }
        }

        changeVideoSource() {
          const currentWidth = window.innerWidth;

          if (this.video) {
            let newSrc;
            if (
              (window.innerWidth >= 750 || this.videoMobileSrc == "") &&
              this.videoDeskSrc
            ) {
              newSrc = this.videoDeskSrc;
            } else if (this.videoMobileSrc) {
              newSrc = this.videoMobileSrc;
            }

            if (newSrc && newSrc !== this.video.src) {
              this.video.src = newSrc;
            }
            this.prevWidth = currentWidth;
          }
        }
      }
    );
  }
});
